import { createReducer, on } from "@ngrx/store";
import { CitiesState } from "../../models/cities-state.model";
import * as citiesActions from "../actions/cities.action";

export const initialCitiesState: CitiesState = {
    cities: [],
    userSelectedCity: null,
    userSelectedCityId: null,
    isLoading: false,
    error: null,
};

export const citiesReducer = createReducer(
    initialCitiesState,
    on(citiesActions.getCities, (state) => {
     
        return {
            ...state,
            isLoading: true,
        };
    }),
    on(citiesActions.getCitiesSuccess, (state, action) => ({
        ...state,
        cities: action.cities,
        isLoading: false,
    })),
    on(citiesActions.getCitiesFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(citiesActions.setUserSelectedCity, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(citiesActions.setUserSelectedCitySuccess, (state, action) => ({
        ...state,
        userSelectedCity: action.city,
        isLoading: false,
    })),
    on(citiesActions.setUserSelectedCityFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    })),
    on(citiesActions.setUserSelectedCityId, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(citiesActions.setUserSelectedCityIdSuccess, (state, action) => ({
        ...state,
        userSelectedCityId: action.city_id,
        isLoading: false,
    })),
    on(citiesActions.setUserSelectedCityIdFailure, (state, action) => ({
        ...state,
        error: action.error,
        isLoading: false,
    }))
);

